"use client";

import React, { useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  Card,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";

const OrderCheckout = () => {
  const { storeCode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] =
    useState(false);

  const cart = useMemo(() => {
    try {
      return JSON.parse(
        localStorage.getItem(
          "store_cart"
        ) || "{}"
      );
    } catch {
      return {};
    }
  }, []);

  const items = Object.values(
    cart[storeCode]?.items || {}
  );

  const description =
    location.state?.description || "";

  const total = items.reduce(
    (sum, item) => {
      const price =
        Number(
          item.product.price ||
            item.product.amount ||
            0
        );

      return (
        sum +
        price * item.quantity
      );
    },
    0
  );

  const createOrder = async () => {
    if (!items.length) {
      toast.error(
        "سبد خرید خالی است."
      );
      return;
    }

    setLoading(true);

    try {
      const payload = {
        storeCode,

        items: items.map((item) => ({
          storeProductCode:
            item.product.code ||
            item.product.storeProductCode,

          quantity: Number(
            item.quantity
          ),
        })),

        description,
      };

      const { data } = await api.post(
        "/orders",
        payload
      );

      const order =
        data?.data || data;

      const orderCode =
        order.orderCode ||
        order.code;

      if (!orderCode) {
        throw new Error(
          "کد سفارش از سرور دریافت نشد."
        );
      }

      // سفارش ساخته شد؛ حالا سبد خالی می‌شود
      const nextCart = {
        ...cart,
      };

      delete nextCart[storeCode];

      localStorage.setItem(
        "store_cart",
        JSON.stringify(nextCart)
      );

      navigate(
        `/user/orders/${orderCode}/payment`,
        {
          state: {
            order,
          },
        }
      );
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "خطا",
        text:
          err?.response?.data?.message ||
          "ثبت سفارش انجام نشد.",
        confirmButtonText:
          "باشه",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="border-0 rounded-3">
      <Card.Body className="p-4">
        <h3 className="mb-4">
          تأیید سفارش
        </h3>

        <Alert variant="info">
          سفارش شما بعد از ثبت در وضعیت
          اولیه قرار می‌گیرد و پرداخت آن
          در مرحله بعد انجام می‌شود.
        </Alert>

        <div className="d-flex justify-content-between border-bottom pb-3 mb-3">
          <span>
            تعداد اقلام
          </span>

          <strong>
            {items.length}
          </strong>
        </div>

        <div className="d-flex justify-content-between mb-4">
          <span>
            مبلغ قابل پرداخت
          </span>

          <strong className="fs-20">
            {total.toLocaleString(
              "fa-IR"
            )}{" "}
            تومان
          </strong>
        </div>

        <Button
          variant="primary"
          size="lg"
          className="w-100"
          onClick={createOrder}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner
                animation="border"
                size="sm"
              />{" "}
              در حال ثبت سفارش...
            </>
          ) : (
            "ثبت سفارش و ادامه پرداخت"
          )}
        </Button>
      </Card.Body>
    </Card>
  );
};

export default OrderCheckout;